import WrapperCard from './WrapperCard';
import { faRedo } from '@fortawesome/free-solid-svg-icons';

const styles = {
  wrapperHeaderStyle: { color: '#FFFFFF', backgroundColor: '#3B5CA9' },
  h3_1: { color: '#FFFFFF', fontSize: '14px', fontWeight: '600', marginBottom: '0' },
  h4_1: { fontSize: '20px' },
  h4_2: { fontSize: '48px', fontWeight: '600' },
  h4_3: { fontSize: '40px', fontWeight: '600' },
  regMiniCard: { borderRight: '2px solid #F0F0F0', borderBottom: 'none' },
  unregMiniCard: { borderRight: '2px solid #F0F0F0', borderBottom: 'none' },
  unMonMiniCard: { borderBottom: 'none' },
  miniCardsHeader: {
    backgroundColor: '#A8A8AA',
    padding: '5px',
  },
  miniCardContainer: {
    padding: '13px',
  },
};

function DeviceStatus({ isLoading, registered, unregistered, unmonitored }) {
  return (
    <WrapperCard
      isLoading={isLoading}
      title="Device Status"
      headerStyle={styles.wrapperHeaderStyle}
      headerIcon={faRedo}
      headerTooltip="Refresh"
      contentSkeletons={2}
      enableCardBody={false}
    >
      <div className="card">
        <div className="row ml-0 mr-0">
          <div className="col-md-4 pl-0 pr-0" style={styles.regMiniCard}>
            <div className="col" style={styles.miniCardsHeader}>
              <h3 style={styles.h3_1}>Registered</h3>
            </div>
            <div
              className="col justify-content-center align-content-center"
              style={styles.miniCardContainer}
            >
              <h4 style={styles.h4_3}>{registered}</h4>
            </div>
          </div>
          <div className="col-md-4 pl-0 pr-0" style={styles.unregMiniCard}>
            <div className="col" style={styles.miniCardsHeader}>
              <h3 style={styles.h3_1}>Unregistered</h3>
            </div>
            <div
              className="col justify-content-center align-content-center"
              style={styles.miniCardContainer}
            >
              <h4 style={styles.h4_3}>{unregistered}</h4>
            </div>
          </div>
          <div className="col-md-4 pl-0 pr-0" style={styles.unMonMiniCard}>
            <div className="col" style={styles.miniCardsHeader}>
              <h3 style={styles.h3_1}>Unmonitored</h3>
            </div>
            <div
              className="col justify-content-center align-content-center"
              style={styles.miniCardContainer}
            >
              <h4 style={styles.h4_3}>{unmonitored}</h4>
            </div>
          </div>
        </div>
      </div>
    </WrapperCard>
  );
}

export default DeviceStatus;
